import React from 'react';
import {Image, ImageBackground, View, StyleSheet} from 'react-native';
import {NativeTouchableOpacity} from '@basicComponents/touchable-opacity';
import Text from '@basicComponents/text';
import {downloadApk} from '@/utils';
import theme from '@/style';
import LinearGradient from '@/components/basic/linear-gradient';

const logoImg = require('@/assets/anna/logos/logo-96.png');
const closeImg = require('@/assets/icons/close-white.webp');
const bgImg = require('@/assets/anna/home/download-bg.webp');

const AnnaDownloadBanner = ({
  visible,
  onClose,
}: {
  visible: boolean;
  onClose: () => void;
}) => {
  if (!visible) {
    return null;
  }

  return (
    <View style={styles.wrap}>
      <LinearGradient colors={['#F9B871', '#F11402']} style={styles.bannerBg} />
      <View style={[theme.flex.row, theme.flex.centerByCol]}>
        <Image source={logoImg} style={styles.logo} />
        <View style={[theme.flex.flex1]}>
          <Text color={theme.basicColor.white} fontSize={12} blod>
            Get your Anna App here
          </Text>
          <Text
            color={'rgba(255,255,255,0.7)'}
            fontSize={10}
            style={styles.subTitle}>
            Start using exclusive services
          </Text>
        </View>
        <NativeTouchableOpacity
          onPress={downloadApk}
          style={styles.downloadBtn}>
          <ImageBackground
            source={bgImg}
            resizeMode="stretch"
            style={styles.downloadBg}>
            <Text color={theme.basicColor.white} fontSize={12} blod>
              DOWNLOAD
            </Text>
          </ImageBackground>
        </NativeTouchableOpacity>
        <NativeTouchableOpacity onPress={onClose}>
          <Image source={closeImg} style={styles.closeIcon} />
        </NativeTouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: {
    paddingHorizontal: 12,
    paddingTop: 2,
    paddingBottom: 2,
    position: 'relative',
    overflow: 'hidden',
  },
  bannerBg: {
    position: 'absolute',
    top: -44,
    left: 0,
    right: 0,
    height: 208,
  },
  logo: {
    width: 28,
    height: 28,
    borderRadius: 8,
    marginRight: 8,
  },
  subTitle: {
    marginTop: 2,
    letterSpacing: -0.2,
    lineHeight: 11,
  },
  downloadBtn: {
    marginRight: 4,
  },
  downloadBg: {
    width: 106,
    height: 38,
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeIcon: {
    width: 20,
    height: 20,
  },
});

export default AnnaDownloadBanner;
